module.exports = __webpack_public_path__ + "img/avalon-21.85236805.png";